"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useContextConfig_1 = __importDefault(require("./useContextConfig"));
var utils_1 = require("../utils");
var useSkeletonConfig = function (config) {
    var animation = config.animation, animationSpeed = config.animationSpeed, backgroundColor = config.backgroundColor, highLightColor = config.highLightColor, secondaryColor = config.secondaryColor;
    (0, useContextConfig_1.default)((0, utils_1.pickBy)({
        animation: animation,
        animationSpeed: animationSpeed,
        backgroundColor: backgroundColor,
        highLightColor: highLightColor,
        secondaryColor: secondaryColor,
    }));
};
exports.default = useSkeletonConfig;
